module.exports = __webpack_public_path__ + "static/media/leaderboard_background2@3x.2174c227.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/leaderboard_background2@3x.png
// module id = 629
// module chunks = 0